import { createPinia } from 'pinia'
import { boot }        from 'quasar/wrappers'

export default boot(async ({ app}) => {
  // Create pinia instance
  const pinia = createPinia()

  // Tell app to use the pinia instance
  app.use(pinia)
})
